var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/helpers/extends", "react", "./IconSvg"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/helpers/extends"), require("react"), require("./IconSvg"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react, global.IconSvg);
    global.ArrowRight = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _react, _IconSvg) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _react = _interopRequireDefault(_react);
  _IconSvg = _interopRequireDefault(_IconSvg);

  var ArrowRight = function ArrowRight(props) {
    return /*#__PURE__*/_react.default.createElement(_IconSvg.default, (0, _extends2.default)({
      name: "arte-icon--next2"
    }, props));
  };

  var _default = ArrowRight;
  _exports.default = _default;
});